import React from "react";

export const Illustration5 = () => {
	return (
		<svg width={386} height={218} viewBox="0 0 386 218" fill="none" xmlns="http://www.w3.org/2000/svg">
			<path
				d="M80.6937 8.2828C3.90621 36.112 -7.65934 174.919 22.1077 216L345.703 216C391.207 167.725 388.363 75.7177 383.244 59.2473C378.125 42.7769 351.391 4.15675 300.199 25.1707C259.246 41.9818 234.838 50.1841 209.811 40.5292C184.784 30.8743 157.481 -19.5464 80.6937 8.2828Z"
				fill="#F5FAFF"
			/>
			<line x1={8.74228e-8} y1={216} x2={369} y2={216} stroke="#315C84" strokeWidth={2} />
			<path
				d="M190 52H324C326.209 52 328 53.7909 328 56V216H186V56C186 53.7909 187.791 52 190 52Z"
				fill="#F9FCFF"
				stroke="#315C84"
				strokeWidth={2}
			/>
			<path
				d="M213 68H302C304.209 68 306 69.7909 306 72V216H209V72L209.005 71.7939C209.112 69.6806 210.86 68 213 68Z"
				fill="#F9FCFF"
				stroke="#315C84"
				strokeWidth={2}
			/>
			<rect x={216} y={97} width={18} height={17} rx={4} fill="#F5FAFF" stroke="#315C84" strokeWidth={2} />
			<line x1={242} y1={101} x2={294} y2={101} stroke="#C4DBF1" strokeWidth={2} />
			<line x1={242} y1={112} x2={271} y2={112} stroke="#C4DBF1" strokeWidth={2} />
			<line x1={242} y1={135} x2={294} y2={135} stroke="#C4DBF1" strokeWidth={2} />
			<line x1={242} y1={147} x2={271} y2={147} stroke="#C4DBF1" strokeWidth={2} />
			<line x1={242} y1={171} x2={294} y2={171} stroke="#C4DBF1" strokeWidth={2} />
			<line x1={242} y1={183} x2={271} y2={183} stroke="#C4DBF1" strokeWidth={2} />
			<path
				d="M43 163H61C63.2091 163 65 164.791 65 167V216H39V167L39.0049 166.794C39.1121 164.681 40.86 163 43 163Z"
				fill="#F9FCFF"
				stroke="#315C84"
				strokeWidth={2}
			/>
			<path
				d="M77 121H95C97.2091 121 99 122.791 99 125V216H73V125C73 122.791 74.7909 121 77 121Z"
				fill="#F9FCFF"
				stroke="#315C84"
				strokeWidth={2}
			/>
			<path
				d="M111 143H129C131.209 143 133 144.791 133 147V216H107V147C107 144.791 108.791 143 111 143Z"
				fill="#86ACCF"
				fillOpacity={0.22}
				stroke="#315C84"
				strokeWidth={2}
			/>
			<path
				d="M145 101H162C164.209 101 166 102.791 166 105V216H141V105C141 102.791 142.791 101 145 101Z"
				fill="#F9FCFF"
				stroke="#315C84"
				strokeWidth={2}
			/>
			<mask id="path-16-inside-1_13119_680" fill="white">
				<path
					fillRule="evenodd"
					clipRule="evenodd"
					d="M256.504 40.926C250.981 40.926 246.504 45.4032 246.504 50.926V54.2687H228.104C222.582 54.2687 218.104 58.7459 218.104 64.2687V78.4123H295.35V64.2687C295.35 58.7459 290.872 54.2687 285.35 54.2687H266.951V50.926C266.951 45.4032 262.474 40.926 256.951 40.926H256.504Z"
				/>
			</mask>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M256.504 40.926C250.981 40.926 246.504 45.4032 246.504 50.926V54.2687H228.104C222.582 54.2687 218.104 58.7459 218.104 64.2687V78.4123H295.35V64.2687C295.35 58.7459 290.872 54.2687 285.35 54.2687H266.951V50.926C266.951 45.4032 262.474 40.926 256.951 40.926H256.504Z"
				fill="#E0EAF4"
			/>
			<path
				d="M246.504 54.2687V56.2687H248.504V54.2687H246.504ZM218.104 64.2687L216.104 64.2687V64.2687H218.104ZM218.104 78.4123H216.104V80.4123H218.104V78.4123ZM295.35 78.4123V80.4123H297.35V78.4123H295.35ZM266.951 54.2687H264.951V56.2687H266.951V54.2687ZM246.504 50.926H248.504C248.504 46.5077 252.085 42.926 256.504 42.926V40.926V38.926C249.876 38.926 244.504 44.2986 244.504 50.926H246.504ZM246.504 54.2687H248.504V50.926H246.504H244.504V54.2687H246.504ZM228.104 54.2687V56.2687H246.504V54.2687V52.2687H228.104V54.2687ZM218.104 64.2687L220.104 64.2687C220.104 59.8505 223.686 56.2687 228.104 56.2687V54.2687V52.2687C221.477 52.2687 216.104 57.6413 216.104 64.2687L218.104 64.2687ZM218.104 78.4123H220.104V64.2687H218.104H216.104V78.4123H218.104ZM295.35 78.4123V76.4123H218.104V78.4123V80.4123H295.35V78.4123ZM295.35 64.2687H293.35V78.4123H295.35H297.35V64.2687H295.35ZM285.35 54.2687V56.2687C289.768 56.2687 293.35 59.8505 293.35 64.2687H295.35H297.35C297.35 57.6413 291.977 52.2687 285.35 52.2687V54.2687ZM266.951 54.2687V56.2687H285.35V54.2687V52.2687H266.951V54.2687ZM266.951 50.926H264.951V54.2687H266.951H268.951V50.926H266.951ZM256.951 40.926V42.926C261.369 42.926 264.951 46.5077 264.951 50.926H266.951H268.951C268.951 44.2986 263.578 38.926 256.951 38.926V40.926ZM256.504 40.926V42.926H256.951V40.926V38.926H256.504V40.926Z"
				fill="#315C84"
				mask="url(#path-16-inside-1_13119_680)"
			/>
			<ellipse cx={257} cy={48.5} rx={3} ry={2.5} fill="#315C84" />
			<line x1={220} y1={68} x2={294} y2={68} stroke="#315C84" strokeWidth={2} />
			<path d="M23 127L80.5385 75.7119L105.923 101.644L155 59" stroke="#C4DBF1" strokeWidth={14} />
			<path d="M172.077 45.3864L168.241 76.2999L140.94 44.4538L172.077 45.3864Z" fill="#C4DBF1" />
			<path d="M219 105L223.278 108L230 102" stroke="#315C84" strokeWidth={2} />
			<rect x={216} y={131} width={18} height={19} rx={4} fill="#F5FAFF" stroke="#315C84" strokeWidth={2} />
			<path d="M219 140L223.278 144L230 136" stroke="#315C84" strokeWidth={2} />
			<rect x={216} y={167} width={18} height={18} rx={4} fill="#F5FAFF" stroke="#315C84" strokeWidth={2} />
			<circle cx={33} cy={83} r={4} fill="#E0EAF4" stroke="#315C84" strokeWidth={2} />
			<circle cx={45} cy={33} r={6} stroke="#315C84" strokeWidth={2} />
			<circle cx={100.5} cy={54.5} r={4.5} fill="#E0EAF4" stroke="#315C84" strokeWidth={2} />
			<circle cx={369.5} cy={179.5} r={4.5} stroke="#315C84" strokeWidth={2} />
			<line x1={349} y1={64} x2={357} y2={64} stroke="#315C84" strokeWidth={2} />
			<line x1={353} y1={60} x2={353} y2={68} stroke="#315C84" strokeWidth={2} />
			<line x1={18} y1={156} x2={26} y2={156} stroke="#315C84" strokeWidth={2} />
			<line x1={22} y1={152} x2={22} y2={160} stroke="#315C84" strokeWidth={2} />
			<line x1={350} y1={192} x2={358} y2={192} stroke="#315C84" strokeWidth={2} />
			<line x1={354} y1={188} x2={354} y2={196} stroke="#315C84" strokeWidth={2} />
			<path
				d="M347.056 121.995L321.871 143.565L315.08 142.994L315.661 136.087L340.834 114.529L347.056 121.995ZM348.488 107.976C348.99 107.545 349.729 107.608 350.153 108.116L354.835 113.733C355.266 114.249 355.201 115.021 354.69 115.458L351.116 118.519L344.892 111.053L348.488 107.976Z"
				fill="#F5FAFF"
				stroke="#315C84"
				strokeWidth={2}
			/>
		</svg>
	);
};
